var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v(" 2023 © srikrunglifebroker.co.th ")]),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"text-md-right footer-links"},[_vm._v(" V. "+_vm._s(_vm.appVersion)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }